import { URLS } from '../config/app-config';
import { secureFetch } from '../utils/secureFetch';

const versionRequests = new Map();

export function sortVersionsDescending(versions = []) {
  return [...versions].sort((left, right) =>
    String(right.code).localeCompare(String(left.code), undefined, {
      numeric: true,
      sensitivity: 'base',
    })
  );
}

export async function fetchPublicVersions({
  apiBase = URLS.apiBase,
  force = false,
} = {}) {
  if (!force && versionRequests.has(apiBase)) {
    return versionRequests.get(apiBase);
  }

  const request = (async () => {
    const base = String(apiBase || '').replace(/\/+$/, '');
    const response = await secureFetch(
      `${base}/admin/versions`
    );
    if (!response.ok) {
      throw new Error(`Could not load available versions (HTTP ${response.status}).`);
    }

    const data = await response.json();
    const publicVersions = Array.isArray(data)
      ? data.filter((version) => version?.public === true && version?.code != null)
          .map((version) => ({ ...version, code: String(version.code) }))
      : [];

    return sortVersionsDescending(publicVersions);
  })();

  versionRequests.set(apiBase, request);
  try {
    return await request;
  } catch (error) {
    versionRequests.delete(apiBase);
    throw error;
  }
}

export function selectHighestVersion(versions = []) {
  return sortVersionsDescending(versions)[0] || null;
}

export function clearVersionCache() {
  versionRequests.clear();
}
